/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, {Component} from 'react';
import {DatePicker, Icon} from 'antd';
import moment from 'moment';
const {MonthPicker, RangePicker, WeekPicker} = DatePicker;

class DateRange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            'dateTo':new Date(),
            'dateFrom':new Date()
        };
    }
    componentDidMount() {
        let dateTo = this.props.dateTo || '';
        let dateFrom = this.props.dateFrom || '';
        this.setState((state)=>({'dateTo':dateTo,'dateFrom':dateFrom}));
        if(dateTo !== null && dateTo !== undefined && dateTo !== '' && dateFrom !== null && dateFrom !== undefined && dateFrom !== ''){
            this.onChangeDate([moment(dateFrom),moment(dateTo)], [dateFrom,dateTo])
           
        }
    }

    componentDidUpdate(prevProps,pervState){
        
        if((prevProps.dateTo != this.props.dateTo) || (prevProps.dateFrom != this.props.dateFrom)){
            this.setState((state)=>({ dateTo:this.props.dateTo, dateFrom:this.props.dateFrom }))
        }
    }

    onChangeDate(date, dateString) {
        console.log(date, dateString,this.props);
        this.props.onselectChanges({id: this.props.selectdata.name,text: dateString, name: this.props.selectdata.name, value: dateString, parrentMode: this.props.selectdata.parrentMode, parrentName: this.props.selectdata.parrentName});
    }

    // handleKeyPress = ($event) => {     if($event.key === 'Enter'){
    // this.props.onInputChanges({enter:true,name:$event.target.name,text:$event.tar
    // g et.value,value:$event.target.value});     }   } onChange($event) {
    // this.props.onInputChanges({enter:false,name:$event.target.name,text:$event.ta
    // r get.value,value:$event.target.value}); }

    render() {
let {dateTo,dateFrom} = this.state;
console.log('SURGERY', this.props)

        // let dateTo = this.state.dateTo || '';
        // let dateFrom = this.state.dateFrom || '';
        return (<RangePicker
            format='DD-MMM-YYYY'
            suffixIcon={false}
            allowClear={false}              
            disabledDate={current => {
                if(this.props.selectdata.name == 'pendingDOCdates'){
                    const weekStart = moment().subtract(15, 'd');
                const weekEnd = moment();
                 return !(weekStart.isSameOrBefore(current) && weekEnd.isAfter(current))
                }
                else if(this.props.selectdata.name =='pre_auth_Daterage'){
                    const weekStart = moment().subtract(20, 'd');
                    const weekEnd = moment();
                    return !(weekStart.isSameOrBefore(current) && weekEnd.isAfter(current))
                }
                else if (this.props.selectdata.name === 'planned_Admissions') {
                    const maxSelectableDate = moment().add(3, 'd');
                    return current > maxSelectableDate;
                  }
                  else if (this.props.selectdata.name === 'surgeries_worklist') {
                    const maxSelectableDate = moment().format('YYYY-MM-DD');
                    return current > maxSelectableDate;
                  }
                else{
                   return current && current > moment()
                }
                
            }}
            inputReadOnly={true}
                  placeholder={['Start Date', 'End Date']}
                  value={[moment(dateFrom),moment(dateTo)]}
            onChange={this
            .onChangeDate
            .bind(this)}/>);
    }
}

export default DateRange;
